import { render, staticRenderFns } from "./CantDown.vue?vue&type=template&id=5d4299c4&scoped=true&"
import script from "./CantDown.vue?vue&type=script&lang=js&"
export * from "./CantDown.vue?vue&type=script&lang=js&"
import style0 from "./CantDown.vue?vue&type=style&index=0&id=5d4299c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4299c4",
  null
  
)

export default component.exports